/**
 * Breadcrumb Display Handler
 * Updates breadcrumbs on product pages using stored navigation context
 */

(function() {
    'use strict';
  
    function updateBreadcrumbsFromContext() {
      // Only run on product pages
      if (!window.location.pathname.includes('/products/')) {
        return;
      }
  
      // Get the breadcrumb elements
      const contextElement = document.querySelector('.js-breadcrumb-context');
      const fallbackElement = document.querySelector('.js-breadcrumb-fallback');
      const contextLink = document.querySelector('.js-breadcrumb-link');
  
      if (!contextElement || !fallbackElement || !contextLink) {
        return;
      }
  
      // Try to get navigation context from sessionStorage
      let navigationContext = null;
      try {
        const stored = sessionStorage.getItem('naptec_navigation_context');
        if (stored) {
          const context = JSON.parse(stored);
          // Check if context is not too old (1 hour)
          if (Date.now() - context.timestamp < 3600000) {
            navigationContext = context;
          }
        }
      } catch (e) {
        // Silently fail if sessionStorage is not available
        console.warn('Could not retrieve navigation context:', e);
      }
  
      // If we have navigation context, use it
      if (navigationContext && navigationContext.collectionUrl && navigationContext.collectionTitle) {
        // Update the context link
        contextLink.href = navigationContext.collectionUrl;
        contextLink.textContent = navigationContext.collectionTitle;
        
        // Show the context breadcrumb and hide the fallback
        contextElement.style.display = '';
        if (fallbackElement) {
          fallbackElement.style.display = 'none';
        }
        
        // Add a class to indicate we're using stored context
        contextElement.classList.add('breadcrumb-from-context');
        
        console.log('Breadcrumb: Using stored navigation context for', navigationContext.collectionTitle);
      } else {
        // No context available, show the fallback
        contextElement.style.display = 'none';
        if (fallbackElement) {
          fallbackElement.style.display = '';
          // Add a class to indicate we're using fallback
          fallbackElement.classList.add('breadcrumb-fallback-active');
        }
        
        console.log('Breadcrumb: Using fallback breadcrumb (no stored context)');
      }
    }
  
    // Initialize when DOM is ready
    function init() {
      updateBreadcrumbsFromContext();
      
      // Also expose the function globally for potential manual calls
      window.NaptecBreadcrumbs = window.NaptecBreadcrumbs || {};
      window.NaptecBreadcrumbs.updateDisplay = updateBreadcrumbsFromContext;
    }
  
    // Run when DOM is ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  
  })();
  